<div class="pagination-wrapper">
  @if (isDefault()) {
    <div>
      {{ "Pagination.Result" | translate }} {{ firstItem }} {{ "Pagination.to" | translate }} {{ lastItem }}
      {{ "Pagination.of" | translate }} {{ pageInfo().totalItems - 1 }}
    </div>
    <pagination-default (nextPage)="nextPage()" (prevPage)="prevPage()" [pageInfo]="pageInfo()"></pagination-default>
  }
  @if (isNumbered()) {
    <div></div>
    <pagination-numbered
      (pageChange)="toPage($event)"
      (pageSizeChanged)="onPageSizeChanged($event)"
      [pageInfo]="pageInfo()"
    ></pagination-numbered>
  }
</div>
